(function () {
    'use strict';
    angular.module('app.service', []);
    angular.module('app.directive', []);
    angular.module('app.filter', ['ngSanitize']);
    angular.module('app', [
        'ui.bootstrap',
        'ngMessages',
        'ngAnimate',
        'angular-loading-bar',
        'ngTouch',
        'ngRoute',
        'pascalprecht.translate',
        'ngSanitize',
        'datePicker',
        'vcRecaptcha',
        'treeControl',
        'blockUI',
        "com.2fdevs.videogular",
        "com.2fdevs.videogular.plugins.controls",
        "com.2fdevs.videogular.plugins.overlayplay",
        "com.2fdevs.videogular.plugins.poster",
        'app.service',
        'app.directive',
        'app.filter'
    ])
        .constant('finacialLicicense', true)
        .constant('sysCode', 'MHR')
        .constant('_sessionDecaySecs', 1200000)
        .config(toastrConfig)
        .config(execptionConfig)
        .config(translateConfig)
        .config(httpConfig)
        .config(blockUIConfig).config(['$locationProvider', function($locationProvider) {
            $locationProvider.hashPrefix('');
        }]);

    function toastrConfig() {
        toastr.options = {
            'closeButton': true,
            'onclick': null,
            'showDuration': '300',
            'hideDuration': '1000',
            'timeOut': '4000',
            'progressBar': true,
            'positionClass': 'toast-top-right',
            'preventDuplicates': true,
            'newestOnTop': true
        };
    }

    function blockUIConfig(blockUIConfig) {
        // Disable automatically blocking of the user interface
        blockUIConfig.autoBlock = false;
        // Change the default delay to 100ms before the blocking is visible 
        blockUIConfig.delay = 100;
        // Provide a custom template to use
        blockUIConfig.template = `
        <div class='block-ui-overlay'></div>
        <div class='block-ui-message-container' aria-live='assertive' aria-atomic='true'>

            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
            <!-- <div class='block-ui-message' ng-class='$_blockUiMessageClass'>
                {{ state.message }}
            </div> -->
        </div>
        `; 


    }

    function execptionConfig($provide, apiUrl) {
        $provide.decorator('$exceptionHandler', function ($delegate) {
            return function (exception, cause) {
                $delegate(exception, cause);
                postException(exception, apiUrl);
            };
        });
    }


    function translateConfig($translateProvider, apiUrl) {

        if (!sessionStorage.getItem('userLang')) {

            getDefaultUserLang(apiUrl.tsApi, navigator.systemLanguage).done(function (data) {

                var userLang = data;
                sessionStorage.setItem('userLang', _.replace(userLang, '_', '-'));
                sessionStorage.setItem('langCode', getLangCode(userLang));

                $translateProvider.useSanitizeValueStrategy('escapeParameters');
                $translateProvider.preferredLanguage(sessionStorage['userLang']);
                $translateProvider.useUrlLoader(apiUrl.tsApi + 'getTranslationResource');
            });

        } else {
            $translateProvider.useSanitizeValueStrategy('escapeParameters');
            $translateProvider.preferredLanguage(sessionStorage['userLang']);
            $translateProvider.useUrlLoader(apiUrl.tsApi + 'getTranslationResource');
        }
    }

    function httpConfig($httpProvider) {
        $httpProvider.interceptors.push('httpInterceptor');
    }

})();